import { render, staticRenderFns } from "./DeactivateModal.vue?vue&type=template&id=0078f3d8"
import script from "./DeactivateModal.vue?vue&type=script&lang=js"
export * from "./DeactivateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports